import moment from "moment";

export default function transformCustomDate (value, format='') {
  if (!value) return ''
  return moment(value).format(format)
}